const isEnabled = true

export const consoleLog = (message: string | any, ...args: any[]): any => {
  if (!isEnabled) return
  console.log(message, ...args)
}

export const consoleTable = (tableObj: Record<string, any>, ...args: any[]) => {
  if (!isEnabled) return
  console.table(tableObj, ...args)
}
